/* @flow */
import type { Action } from './types';

export const RECORD_SEARCH_TERM = 'RECORD_SEARCH_TERM';
export const SET_LAST_FETCHED_LOCATION = 'SET_LAST_FETCHED_LOCATION';
export const FINISH_FETCHING = 'FINISH_FETCHING';
export const UNSET_INITIAL_PAGEVIEW = 'UNSET_INITIAL_PAGEVIEW';

export const recordSearchTerm = (searchTerm: string): Action => ({
  type: RECORD_SEARCH_TERM,
  searchTerm
});

export const setLastFetchedLocation =
  (location: LastFetchedLocation): Action => ({
    type: SET_LAST_FETCHED_LOCATION,
    location
  });

/*
 * Dispatched by our routing logic when all AJAX requests
 * (including any requests for additional Webpack bundles)
 * are complete.
 */
export const finishFetching = (): Action => ({
  type: FINISH_FETCHING
});

export const unsetInitialPageview = (): Action => ({
  type: UNSET_INITIAL_PAGEVIEW
});

export type LastFetchedLocation = {
  pathname: string,
  query: Object
};
